import React, {Component} from 'react';
import styles from './Form.module.css';


class Form extends Component {

    render() {

        return (
            <div className={styles.root} style={this.props.style}>
                <div>
                    {this.props.children}
                </div>
            </div>
        )
    }
}

export default Form;
